import {
  FETCH_SUBCATEGORIES_REQUEST,
  FETCH_SUBCATEGORIES_SUCCESS,
  FETCH_SUBCATEGORIES_FAILURE,
  SAVE_SUBCATEGORY_REQUEST,
  SAVE_SUBCATEGORY_SUCCESS,
  SAVE_SUBCATEGORY_FAILURE,
  DELETE_SUBCATEGORY_REQUEST,
  DELETE_SUBCATEGORY_SUCCESS,
  DELETE_SUBCATEGORY_FAILURE,
} from './types';

const INITIAL_STATE = {
  subcategoryList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SUBCATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_SUBCATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        subcategoryList: action.payload,
      };

    case FETCH_SUBCATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        subcategoryList: [],
      };
    case SAVE_SUBCATEGORY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_SUBCATEGORY_SUCCESS:
      return {
        ...state,
      };

    case SAVE_SUBCATEGORY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_SUBCATEGORY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_SUBCATEGORY_SUCCESS:
      return {
        ...state,
      };

    case DELETE_SUBCATEGORY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
